import { ActionKeys } from '~/actions/constants';
import { type ActionTypes } from '~/actions/index';
import { type SeverityType } from '~/components/SnackbarAlert/types';

export interface SnackbarState {
  i18n: boolean;
  i18nValues?: Record<string, unknown>;
  id: number;
  message: null | string;
  severity: SeverityType;
}

const initialState: SnackbarState = {
  i18n: false,
  i18nValues: undefined,
  id: 0,
  message: null,
  severity: 'success',
};

const snackbarReducer = (
  state: SnackbarState = initialState,
  action: ActionTypes,
): SnackbarState => {
  switch (action.type) {
    case ActionKeys.SNACKBAR_ADD_MESSAGE:
      return {
        ...state,
        i18n: action.payload.i18n,
        i18nValues: action.payload.i18nValues,
        id: state.id + 1,
        message: action.payload.message,
        severity: action.payload.severity,
      };
    default:
      return state;
  }
};

export default snackbarReducer;
